import { RestService } from './rest.service';
import { Injectable } from '@angular/core';
import { GeneralConstants } from 'src/app/core/constants/general.constants';
import { TarifarioResponse } from 'src/app/core/models/response/tarifario.response';
import { PlanMedioPagoModel } from 'src/app/core/models/response/plan-medio-pago.model';
import { toSubscribeTarifario } from 'src/app/core/mappers/tarifario.mapper';

@Injectable()
export class TarifarioService {
  constructor(private restService: RestService) {}

  public async getPlanesTipoMedioPago(): Promise<PlanMedioPagoModel[]> {
    try {
      const response = await this.restService.get(GeneralConstants.tarifarioPlanes);
      return response.listOfResults.listOfResult;
    } catch (error) {
      Promise.reject(error);
    }
  }

  public async subscribeTarifario(
    subscribe: boolean,
    tipoMedioPagoId: number[],
    agrupador: boolean = false
  ): Promise<any> {
    try {
      const request = toSubscribeTarifario(subscribe, tipoMedioPagoId, agrupador);
      const response = await this.restService.post(GeneralConstants.tarifarioSubscribe, request);
      return response.object;
    } catch (error) {
      return Promise.reject(error.message);
    }
  }

  public async getSubscripciones(): Promise<TarifarioResponse[]> {
    try {
      const response = await this.restService.get(GeneralConstants.tarifarioSubscripciones);
      return response.listOfResults.listOfResult;
    } catch (error) {
      return Promise.reject(error.message);
    }
  }
}
